import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { PLATFORMS } from "shared/types/enums";

import { FirstStepButtonsProps } from "../types";

const FirstStepButtons = ({ changePlatform }: FirstStepButtonsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Button
                fullWidth
                color={BUTTON_COLORS.PrimarySubtle}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.TextOnly}
                onClick={() => changePlatform(PLATFORMS.Ft)}
            >
                {t("Button##ft platform")}
            </Button>

            <Button
                fullWidth
                color={BUTTON_COLORS.PrimarySubtle}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.TextOnly}
                onClick={() => changePlatform(PLATFORMS.Fmx)}
            >
                {t("Button##fmx and legacy")}
            </Button>
        </>
    );
};

export { FirstStepButtons };
